import { ImageHelper } from '@/lib/helpers/image.helper'

// Kích thước ảnh hero desktop như hero cũ (HeroBanner): 2048x787.
// Width dùng chung cho <img> và preload ở page.tsx để trình duyệt chỉ tải một URL ảnh LCP.
export const HOME_HERO_DESKTOP_SIZE = { width: 2048, height: 787 } as const

export function getHomeHeroDesktopImageUrl(image: string): string {
  return ImageHelper.getImageUrl(image, '', HOME_HERO_DESKTOP_SIZE.width)
}
